export const numberIfNotUndefined = (
  value: number | undefined | null | string,
) => {
  if (value === '' || value === null || value === undefined) return undefined;
  const number = Number(value);
  return Number.isNaN(number) ? undefined : number;
};
